// extracted by mini-css-extract-plugin
module.exports = {"bubble":"commentBubble_bubble__7g__w","hidden":"commentBubble_hidden__Z6tkv"};